import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <linearGradient id="xl2lol99jb" x1="50%" x2="50%" y1="99.39%" y2="0%">
          <stop offset="0%" stopColor="#FFBD3F" />
          <stop offset="100%" stopColor="#FFCC37" />
        </linearGradient>
        <rect id="t7fzx9o99a" width="24" height="24" x="0" y="0" rx="12" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-257 -484) translate(204 355.757) translate(53 128.243)">
              <mask id="1udyobsuuc" fill="#fff">
                <use xlinkHref="#t7fzx9o99a" />
              </mask>
              <use fill="url(#xl2lol99jb)" xlinkHref="#t7fzx9o99a" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M11.99 3.842c-.016.003-.033.007-.048.012-.18.04-.307.203-.303.388v2.329c-.001.14.072.27.192.34.121.07.27.07.39 0 .122-.07.194-.2.193-.34V4.242c.004-.112-.041-.22-.121-.296-.082-.077-.192-.115-.303-.104zm-5.515 2.28c-.145.026-.262.132-.303.273-.04.142.002.294.11.394l1.644 1.65c.094.115.244.168.389.134.143-.033.257-.147.29-.29.033-.146-.02-.296-.135-.39l-1.645-1.65c-.08-.086-.196-.13-.314-.121h-.036zm10.982 0c-.087.012-.169.056-.23.121l-1.644 1.65c-.115.094-.168.244-.135.39.033.143.147.257.29.29.145.034.295-.02.389-.135l1.645-1.649c.12-.115.156-.296.085-.447-.073-.153-.233-.241-.4-.22zm-5.43 2.001c-2.135 0-3.871 1.74-3.871 3.881s1.736 3.881 3.87 3.881c2.135 0 3.871-1.74 3.871-3.88 0-2.141-1.736-3.882-3.87-3.882zm-7.85 3.493c-.214.03-.363.23-.333.443.03.214.228.364.441.333h2.323c.139.002.269-.07.34-.192.07-.121.07-.27 0-.391-.071-.122-.201-.194-.34-.193H4.177zm13.16 0c-.214.03-.363.23-.333.443.03.214.228.364.441.333h2.323c.139.002.269-.07.34-.192.07-.121.07-.27 0-.391-.071-.122-.201-.194-.34-.193h-2.432zM8.155 15.45c-.088.012-.17.056-.23.121l-1.645 1.65c-.115.094-.168.244-.134.39.033.143.146.257.29.29.145.034.295-.02.388-.135l1.645-1.65c.115-.11.15-.281.088-.428-.06-.147-.207-.241-.366-.238h-.036zm7.62 0c-.145.026-.261.132-.302.273-.041.142.001.294.109.394l1.645 1.65c.093.115.243.168.388.134.144-.033.257-.147.29-.29.034-.146-.02-.296-.134-.39l-1.645-1.65c-.073-.077-.172-.12-.278-.121h-.073zm-3.786 1.589c-.016.003-.033.007-.048.012-.18.04-.307.203-.303.388v2.329c-.001.14.072.27.192.34.121.07.27.07.39 0 .122-.07.194-.2.193-.34v-2.33c.004-.111-.041-.219-.121-.295-.082-.077-.192-.115-.303-.104z"
                mask="url(#1udyobsuuc)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Icon
